import { render } from "./chaxunb.vue?vue&type=template&id=20a46772&scoped=true"
import script from "./chaxunb.vue?vue&type=script&lang=js"
export * from "./chaxunb.vue?vue&type=script&lang=js"

import "./chaxunb.vue?vue&type=style&index=0&id=20a46772&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20a46772"

export default script